(function (root, factory) {
  var stickyCart = factory(root);

  if (typeof module === "object" && module.exports) {
    module.exports = stickyCart;
    return;
  }

  root.LevyStickyAddToCart = stickyCart;

  function start() {
    stickyCart.init(root.document);
  }

  if (root.document.readyState === "loading") {
    root.document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  root.document.addEventListener("shopify:section:load", start);
  root.document.addEventListener("venue:variant:updated", function (event) {
    stickyCart.handleVariantUpdate(event, root.document);
  });
})(typeof window !== "undefined" ? window : globalThis, function (root) {
  "use strict";

  var merchantObserverStarted = false;
  var MERCHANT_WIDGET_BOTTOM = "calc(100px + env(safe-area-inset-bottom))";
  var MOBILE_QUERY = "(max-width: 767px)";

  function compactText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function normalizeVariantTitle(value) {
    var title = compactText(value);
    return title.toLowerCase() === "default title" ? "" : title;
  }

  function findScope(bar, document) {
    return bar.closest(".section--product-single") ||
      bar.closest(".shopify-section") ||
      document;
  }

  function selectedVariantTitle(scope) {
    var select = scope.querySelector(".js-product-variant-select");
    if (!select || select.selectedIndex < 0) {
      return "";
    }

    return normalizeVariantTitle(select.options[select.selectedIndex].text);
  }

  function setVisibility(bar, visible) {
    bar.classList.toggle("is-visible", visible);
    bar.setAttribute("aria-hidden", String(!visible));
  }

  function syncBar(bar, document, variant) {
    var scope = findScope(bar, document);
    var mainButton = scope.querySelector(".js-product-add");
    var mainButtonText = mainButton && mainButton.querySelector(".js-product-add-text");
    var price = scope.querySelector(".js-product-price-number");
    var shipping = scope.querySelector(".js-shipping-origin");
    var stickyButton = bar.querySelector(".js-sticky-add-to-cart-button");
    var stickyButtonText = bar.querySelector("[data-sticky-add-text]");
    var stickyPrice = bar.querySelector("[data-sticky-product-price]");
    var stickyVariant = bar.querySelector("[data-sticky-product-variant]");
    var stickyShipping = bar.querySelector("[data-sticky-shipping]");
    var stickyShippingText = bar.querySelector("[data-sticky-shipping-text]");

    if (price && stickyPrice) {
      stickyPrice.textContent = compactText(price.innerText || price.textContent);
    }

    var variantTitle = normalizeVariantTitle(
      variant && variant.title ? variant.title : selectedVariantTitle(scope)
    );
    if (stickyVariant) {
      stickyVariant.textContent = variantTitle;
      stickyVariant.hidden = !variantTitle;
    }

    if (variant && variant.id) {
      bar.dataset.variantId = String(variant.id);
    }

    if (mainButton && stickyButton) {
      stickyButton.disabled = mainButton.disabled ||
        mainButton.getAttribute("aria-disabled") === "true";
      stickyButton.setAttribute(
        "aria-busy",
        mainButton.getAttribute("aria-busy") || "false"
      );
    }

    if (mainButtonText && stickyButtonText) {
      stickyButtonText.textContent = compactText(mainButtonText.textContent);
    }

    if (shipping && stickyShipping) {
      stickyShipping.hidden = shipping.hidden;
      if (!shipping.hidden && stickyShippingText) {
        var sourceShippingText = shipping.querySelector("[data-shipping-origin-text]");
        if (sourceShippingText) {
          stickyShippingText.textContent = compactText(sourceShippingText.textContent);
        }
      }
    }
  }

  function observeSources(bar, document) {
    if (typeof root.MutationObserver !== "function") {
      return;
    }

    var scope = findScope(bar, document);
    var sources = [
      scope.querySelector(".js-product-add"),
      scope.querySelector(".js-product-price-number"),
      scope.querySelector(".js-shipping-origin")
    ].filter(Boolean);
    var observer = new root.MutationObserver(function () {
      syncBar(bar, document);
    });

    sources.forEach(function (source) {
      observer.observe(source, {
        attributes: true,
        attributeFilter: ["aria-busy", "aria-disabled", "class", "disabled", "hidden"],
        childList: true,
        subtree: true
      });
    });
  }

  function observeMainButton(bar, document) {
    var scope = findScope(bar, document);
    var mainButton = scope.querySelector(".js-product-add");

    if (!mainButton) {
      return;
    }

    if (typeof root.IntersectionObserver !== "function") {
      setVisibility(bar, true);
      return;
    }

    var observer = new root.IntersectionObserver(function (entries) {
      if (entries.length) {
        setVisibility(bar, !entries[0].isIntersecting);
      }
    }, {
      threshold: 0.25
    });

    observer.observe(mainButton);
  }

  function connectMerchantWidget(widget) {
    if (widget.hasAttribute("data-sticky-cart-positioned")) {
      return;
    }

    var originalBottom = widget.style.getPropertyValue("bottom");
    var originalPriority = widget.style.getPropertyPriority("bottom");
    widget.setAttribute("data-sticky-cart-positioned", "");

    function applyPosition() {
      var isMobile = typeof root.matchMedia !== "function" ||
        root.matchMedia(MOBILE_QUERY).matches;

      if (isMobile) {
        if (
          widget.style.getPropertyValue("bottom") !== MERCHANT_WIDGET_BOTTOM ||
          widget.style.getPropertyPriority("bottom") !== "important"
        ) {
          widget.style.setProperty("bottom", MERCHANT_WIDGET_BOTTOM, "important");
        }
      } else if (originalBottom) {
        if (
          widget.style.getPropertyValue("bottom") !== originalBottom ||
          widget.style.getPropertyPriority("bottom") !== originalPriority
        ) {
          widget.style.setProperty("bottom", originalBottom, originalPriority);
        }
      } else {
        if (widget.style.getPropertyValue("bottom")) {
          widget.style.removeProperty("bottom");
        }
      }
    }

    applyPosition();

    if (typeof root.MutationObserver === "function") {
      var styleObserver = new root.MutationObserver(applyPosition);
      styleObserver.observe(widget, {
        attributes: true,
        attributeFilter: ["style"]
      });
    }

    if (typeof root.addEventListener === "function") {
      root.addEventListener("resize", applyPosition);
    }
  }

  function observeMerchantWidget(document) {
    if (merchantObserverStarted) {
      return;
    }

    merchantObserverStarted = true;

    function connectIfPresent() {
      var widget = document.getElementById("google-merchantwidget-iframe-wrapper");
      if (widget) {
        connectMerchantWidget(widget);
        return true;
      }

      return false;
    }

    if (connectIfPresent() || typeof root.MutationObserver !== "function") {
      return;
    }

    var observer = new root.MutationObserver(function () {
      if (connectIfPresent()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function connectButton(bar, document) {
    var stickyButton = bar.querySelector(".js-sticky-add-to-cart-button");
    if (!stickyButton) {
      return;
    }

    stickyButton.addEventListener("click", function () {
      var scope = findScope(bar, document);
      var mainButton = scope.querySelector(".js-product-add");

      syncBar(bar, document);
      if (mainButton && !mainButton.disabled) {
        mainButton.click();
      }
    });
  }

  function initializeBar(bar, document) {
    bar.setAttribute("data-sticky-add-to-cart-ready", "");
    bar.hidden = false;
    syncBar(bar, document);
    connectButton(bar, document);
    observeSources(bar, document);
    observeMainButton(bar, document);
  }

  function init(document) {
    if (!document) {
      return;
    }

    var bars = Array.prototype.slice.call(
      document.querySelectorAll(
        ".js-sticky-add-to-cart:not([data-sticky-add-to-cart-ready])"
      )
    );

    bars.forEach(function (bar) {
      initializeBar(bar, document);
    });

    if (bars.length) {
      observeMerchantWidget(document);
    }
  }

  function handleVariantUpdate(event, document) {
    var detail = event && event.detail;
    if (!detail || !document) {
      return;
    }

    var scope = detail.sectionClass
      ? document.querySelector(detail.sectionClass) || document
      : document;
    var bars = Array.prototype.slice.call(
      scope.querySelectorAll(".js-sticky-add-to-cart")
    );

    bars.forEach(function (bar) {
      syncBar(bar, document, detail.variant);
    });
  }

  return {
    compactText: compactText,
    handleVariantUpdate: handleVariantUpdate,
    init: init,
    normalizeVariantTitle: normalizeVariantTitle
  };
});
